import type { Profile } from '@/app/types'
import type { ActiveNumbers } from '@/modules/admin/resources'

import type { PhoneBookType, NumberRecordType } from '../types'

export const formattedData = (data: ActiveNumbers[] = []) => {
  if (!data) return []

  const phoneBookArr = new Map<string, NumberRecordType>()
  const allNumbers = new Map<string, NumberRecordType>()

  const departmentsList = new Map<number, PhoneBookType>()
  const telePoliciesList = new Map<number, PhoneBookType>()
  const groupsList = new Map<number, PhoneBookType>()

  const final: PhoneBookType[] = []

  data.forEach(item => {
    addNumbers(allNumbers, item)

    const { is_on_phone_book } = item

    if (is_on_phone_book === 'YES') {
      addNumbers(phoneBookArr, item)
    }

    const { department_id, department_name } = item

    if (department_id && department_name) {
      addToPhoneBook(departmentsList, item, {
        id: department_id,
        name: department_name,
        type: 'department',
      })
    }

    const { salary_deduction_profile_id, salary_deduction_profile_name } = item

    if (salary_deduction_profile_id && salary_deduction_profile_name) {
      addToPhoneBook(telePoliciesList, item, {
        id: salary_deduction_profile_id,
        name: salary_deduction_profile_name,
        type: 'tele-policy',
      })
    }

    const { group_id, group_name } = item

    if (group_id && group_name) {
      addToPhoneBook(groupsList, item, { id: group_id, name: group_name, type: 'group' })
    }
  })

  final.push(
    {
      id: 'all',
      name: 'All numbers',
      type: 'all',
      numbers: allNumbers,
    },
    {
      id: 'phone-book',
      name: 'Phone book',
      type: 'phone-book',
      numbers: phoneBookArr,
    }
  )
  if (departmentsList.size > 0) {
    final.push({
      id: 'departments',
      name: 'Departments',
      type: 'department',
      children: departmentsList,
    })
  }

  if (telePoliciesList.size > 0) {
    final.push({
      id: 'telePolicies',
      name: 'Tele-Policies',
      type: 'tele-policy',
      children: telePoliciesList,
    })
  }

  if (groupsList.size > 0) {
    final.push({
      id: 'groups',
      name: 'Groups',
      type: 'group',
      children: groupsList,
    })
  }

  return final
}

export const addNumbers = (map: Map<string, NumberRecordType>, number: ActiveNumbers) => {
  const {
    id,
    name,
    country_id: countryId,
    phone_number: phoneNumber,
    full_phone_number: fullNumber,
  } = number

  map.set(fullNumber, { id, name, countryId, number: phoneNumber })

  return map
}

export const addToPhoneBook = (
  map: Map<number, PhoneBookType>,
  number: ActiveNumbers,
  options: {
    id: number
    name: string
    type: 'department' | 'tele-policy' | 'group'
  }
) => {
  const { id, name, type } = options

  const found = map.get(id)

  if (found) {
    addNumbers(found.numbers!, number)
  } else {
    const numbers = new Map<string, NumberRecordType>()
    addNumbers(numbers, number)
    map.set(id, { id, name, type, numbers })
  }

  return map
}

export const renderSenderOptions = (user?: Profile) => {
  if (!user) return []

  return [
    {
      label: user.username,
      value: user.username,
    },
    {
      label: user.name,
      value: user.name,
    },
    {
      label: user.phoneNumber,
      value: user.phoneNumber,
    },

    {
      label: user.customerName,
      value: user.customerName,
    },
  ]
}
